var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.231015 0.892986C0.304284 0.819693 0.391274 0.761553 0.487018 0.721885C0.582761 0.682218 0.68538 0.661801 0.789015 0.661801C0.89265 0.661801 0.99527 0.682218 1.09101 0.721885C1.18676 0.761553 1.27375 0.819693 1.34702 0.892986L5.00002 4.54499L8.65202 0.892986C8.80001 0.744863 9.00078 0.661596 9.21016 0.661502C9.41955 0.661408 9.62039 0.744496 9.76852 0.892487C9.91664 1.04048 9.99991 1.24125 10 1.45063C10.0001 1.66002 9.91701 1.86086 9.76902 2.00899L5.55802 6.21999C5.48475 6.29328 5.39776 6.35142 5.30201 6.39109C5.20627 6.43076 5.10365 6.45117 5.00002 6.45117C4.89638 6.45117 4.79376 6.43076 4.69802 6.39109C4.60227 6.35142 4.51528 6.29328 4.44202 6.21999L0.231015 2.00899C0.157722 1.93572 0.0995808 1.84873 0.0599136 1.75298C0.0202465 1.65724 -0.000170708 1.55462 -0.000170708 1.45099C-0.000170708 1.34735 0.0202465 1.24473 0.0599136 1.14899C0.0995808 1.05325 0.157722 0.966255 0.231015 0.892986Z",
    fill: "#262836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.49ef0e8c25ec45a20b32b4e48dee36fb.svg";
export { ForwardRef as ReactComponent };